import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function MenuSection() {
  const [activeCategory, setActiveCategory] = useState('makanan');
  const [favorites, setFavorites] = useState<string[]>([]);

  const menuCategories = [
    { id: 'makanan', name: 'Makanan', icon: 'ri-bowl-line', color: 'red' },
    { id: 'minuman', name: 'Minuman', icon: 'ri-cup-line', color: 'yellow' }
  ];

  const menuItems = {
    makanan: [
      {
        id: 'ramen-tonkotsu',
        name: 'Tonkotsu Ramen Deluxe',
        price: 75000,
        description: 'Kuah tulang babi premium dengan telur ajitsuke, chashu, dan bambu menma',
        image: 'https://public.readdy.ai/ai/img_res/01d74b22515f8f63ecaf66555676f008.jpg',
        category: 'Ramen',
        spicy: false,
        popular: true,
        halal: false
      },
      {
        id: 'ramen-miso',
        name: 'Miso Ramen Futuristik',
        price: 65000,
        description: 'Ramen miso dengan sentuhan modern, dilengkapi sayuran segar dan jamur shiitake',
        image: 'https://readdy.ai/api/search-image?query=Modern%20miso%20ramen%20with%20rich%20brown%20broth%2C%20shiitake%20mushrooms%2C%20corn%20kernels%2C%20seaweed%2C%20bean%20sprouts%2C%20green%20onions%2C%20futuristic%20presentation%20in%20black%20bowl%2C%20professional%20food%20photography%2C%20Japanese%20cuisine&width=400&height=300&seq=ramen-miso-futuristik&orientation=landscape',
        category: 'Ramen',
        spicy: false,
        popular: false,
        halal: true
      },
      {
        id: 'sushi-omakase',
        name: 'Omakase Sushi Set',
        price: 150000,
        description: 'Set sushi pilihan chef dengan 12 pieces nigiri sushi premium',
        image: 'https://readdy.ai/api/search-image?query=Premium%20omakase%20sushi%20set%20with%2012%20pieces%20of%20nigiri%20sushi%2C%20fresh%20salmon%2C%20tuna%2C%20yellowtail%2C%20sea%20urchin%2C%20elegant%20wooden%20board%20presentation%2C%20wasabi%20and%20pickled%20ginger%2C%20high-end%20Japanese%20restaurant%20quality&width=400&height=300&seq=sushi-omakase-set&orientation=landscape',
        category: 'Sushi',
        spicy: false,
        popular: true,
        halal: false
      },
      {
        id: 'tempura-set',
        name: 'Tempura Premium Set',
        price: 85000,
        description: 'Tempura udang dan sayuran dengan tepung crispy dan saus tentsuyu',
        image: 'https://readdy.ai/api/search-image?query=Premium%20tempura%20set%20with%20crispy%20shrimp%20and%20vegetable%20tempura%2C%20golden%20brown%20coating%2C%20tentsuyu%20dipping%20sauce%2C%20elegant%20Japanese%20presentation%2C%20professional%20food%20photography&width=400&height=300&seq=tempura-premium-set&orientation=landscape',
        category: 'Tempura',
        spicy: false,
        popular: false,
        halal: true
      },
      {
        id: 'gyoza-premium',
        name: 'Gyoza Premium',
        price: 45000,
        description: '6 pieces gyoza dengan isian daging dan sayuran, pan-fried hingga crispy',
        image: 'https://readdy.ai/api/search-image?query=Premium%20gyoza%20dumplings%20pan-fried%20until%20golden%20crispy%2C%206%20pieces%20arranged%20on%20black%20plate%2C%20dipping%20sauce%2C%20steam%20rising%2C%20traditional%20Japanese%20appetizer%2C%20restaurant%20quality%20presentation&width=400&height=300&seq=gyoza-premium&orientation=landscape',
        category: 'Appetizer',
        spicy: false,
        popular: true,
        halal: true
      },
      {
        id: 'takoyaki-osaka',
        name: 'Takoyaki Osaka Style',
        price: 35000,
        description: '6 balls takoyaki dengan saus mayo, katsuobushi, dan aonori',
        image: 'https://readdy.ai/api/search-image?query=Osaka%20style%20takoyaki%20octopus%20balls%20with%20takoyaki%20sauce%2C%20mayonnaise%20drizzle%2C%20bonito%20flakes%2C%20seaweed%20powder%2C%206%20pieces%20on%20traditional%20takoyaki%20board%2C%20hot%20and%20steaming%2C%20Japanese%20street%20food&width=400&height=300&seq=takoyaki-osaka&orientation=landscape',
        category: 'Appetizer',
        spicy: false,
        popular: true,
        halal: false
      }
    ],
    minuman: [
      {
        id: 'matcha-latte',
        name: 'Matcha Latte Premium',
        price: 35000,
        description: 'Matcha authentic dari Uji dengan susu premium dan foam art',
        image: 'https://readdy.ai/api/search-image?query=Premium%20matcha%20latte%20with%20beautiful%20foam%20art%2C%20vibrant%20green%20matcha%20color%2C%20ceramic%20cup%20and%20saucer%2C%20Japanese%20tea%20ceremony%20aesthetic%2C%20modern%20cafe%20presentation%2C%20authentic%20Uji%20matcha&width=400&height=300&seq=matcha-latte-premium&orientation=landscape',
        category: 'Hot Drinks',
        popular: true,
        halal: true
      },
      {
        id: 'sake-premium',
        name: 'Sake Premium',
        price: 55000,
        description: 'Sake premium pilihan, bisa disajikan panas atau dingin',
        image: 'https://readdy.ai/api/search-image?query=Premium%20Japanese%20sake%20served%20in%20traditional%20ceramic%20tokkuri%20and%20ochoko%20cups%2C%20elegant%20presentation%20on%20wooden%20tray%2C%20warm%20lighting%2C%20traditional%20Japanese%20alcohol%20service%2C%20restaurant%20quality&width=400&height=300&seq=sake-premium&orientation=landscape',
        category: 'Alcohol',
        popular: false,
        halal: false
      },
      {
        id: 'ramune-soda',
        name: 'Ramune Soda',
        price: 25000,
        description: 'Soda Jepang traditional dengan marble ball, rasa original',
        image: 'https://readdy.ai/api/search-image?query=Traditional%20Japanese%20ramune%20soda%20bottle%20with%20marble%20ball%2C%20clear%20blue%20tinted%20glass%20bottle%2C%20condensation%20droplets%2C%20refreshing%20summer%20drink%2C%20Japanese%20beverage%2C%20traditional%20packaging&width=400&height=300&seq=ramune-soda&orientation=landscape',
        category: 'Cold Drinks',
        popular: true,
        halal: true
      },
      {
        id: 'green-tea',
        name: 'Ocha (Green Tea)',
        price: 15000,
        description: 'Teh hijau Jepang authentic disajikan panas dalam kyusu',
        image: 'https://readdy.ai/api/search-image?query=Traditional%20Japanese%20green%20tea%20ocha%20served%20in%20ceramic%20kyusu%20teapot%20with%20small%20cups%2C%20steam%20rising%2C%20zen%20atmosphere%2C%20traditional%20tea%20ceremony%2C%20minimalist%20presentation&width=400&height=300&seq=ocha-green-tea&orientation=landscape',
        category: 'Hot Drinks',
        popular: false,
        halal: true
      }
    ]
  };

  const toggleFavorite = (itemId: string) => {
    setFavorites(prev => 
      prev.includes(itemId) 
        ? prev.filter(id => id !== itemId)
        : [...prev, itemId]
    );
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.querySelector(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="menu" className="py-20 bg-gradient-to-b from-gray-900 to-black dark:from-gray-800 dark:to-gray-900">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-black text-white mb-6" style={{ fontFamily: '"Noto Sans JP", serif' }}>
            Menu <span className="text-red-500">Unggulan</span>
            <span className="block text-3xl text-yellow-400 mt-2">特別メニュー</span>
          </h2>
          <div className="flex items-center justify-center space-x-4 mb-8">
            <div className="h-px w-20 bg-gradient-to-r from-transparent to-red-500"></div>
            <div className="text-yellow-400 text-lg font-bold" style={{ fontFamily: '"Orbitron", sans-serif' }}>
              AUTHENTIC JAPANESE CUISINE
            </div>
            <div className="h-px w-20 bg-gradient-to-l from-transparent to-red-500"></div>
          </div>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            Nikmati koleksi menu autentik Jepang yang dibuat dengan resep tradisional dan bahan-bahan premium langsung dari Jepang
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex justify-center gap-4 mb-12">
          {menuCategories.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveCategory(category.id)}
              className={`flex items-center space-x-3 px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                activeCategory === category.id
                  ? `bg-gradient-to-r ${category.color === 'red' ? 'from-red-600 to-red-700' : 'from-yellow-600 to-yellow-700'} text-white shadow-lg transform scale-110`
                  : 'bg-gray-800 text-gray-300 hover:bg-gray-700 hover:text-white hover:scale-105'
              }`}
            >
              <i className={`${category.icon} w-6 h-6 flex items-center justify-center`}></i>
              <span>{category.name}</span>
              <span className="bg-white/20 text-xs px-2 py-1 rounded-full">
                {menuItems[category.id as keyof typeof menuItems].length}
              </span>
            </button>
          ))}
        </div>

        {/* Menu Items Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {menuItems[activeCategory as keyof typeof menuItems].map((item) => (
            <div
              key={item.id}
              className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-3xl border border-red-500/20 overflow-hidden hover:transform hover:scale-105 hover:border-red-500/40 transition-all duration-300 group"
            >
              <div className="relative">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-56 object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                
                {/* Badges */}
                <div className="absolute top-4 left-4 flex flex-wrap gap-2">
                  {item.popular && (
                    <span className="bg-red-500 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
                      ⭐ POPULER
                    </span>
                  )}
                  {item.spicy && (
                    <span className="bg-orange-500 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
                      🌶️ PEDAS
                    </span>
                  )}
                  {item.halal && (
                    <span className="bg-green-500 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
                      ✅ HALAL
                    </span>
                  )}
                </div>

                {/* Favorite Button */}
                <button
                  onClick={() => toggleFavorite(item.id)}
                  className={`absolute top-4 right-4 w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer ${
                    favorites.includes(item.id)
                      ? 'bg-red-500 text-white shadow-lg'
                      : 'bg-white/20 text-white hover:bg-white/30'
                  }`}
                >
                  <i className={`${favorites.includes(item.id) ? 'ri-heart-fill' : 'ri-heart-line'} w-5 h-5 flex items-center justify-center`}></i>
                </button>

                {/* Price */}
                <div className="absolute bottom-4 right-4">
                  <span className="bg-yellow-500 text-black px-4 py-2 rounded-full font-bold text-lg shadow-lg">
                    Rp {item.price.toLocaleString('id-ID')}
                  </span>
                </div>

                {/* Category */}
                <div className="absolute bottom-4 left-4">
                  <span className="bg-black/60 text-white px-3 py-1 rounded-full text-sm font-medium">
                    {item.category}
                  </span>
                </div>
              </div>

              <div className="p-6">
                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-red-400 transition-colors">
                  {item.name}
                </h3>
                <p className="text-gray-300 text-sm leading-relaxed mb-6 h-12 overflow-hidden">
                  {item.description}
                </p>
                
                <div className="flex gap-3">
                  <Link to="/customer" className="flex-1">
                    <Button variant="primary" size="sm" className="w-full whitespace-nowrap cursor-pointer">
                      <i className="ri-shopping-cart-line mr-2 w-4 h-4 flex items-center justify-center"></i>
                      Pesan
                    </Button>
                  </Link>
                  <Button 
                    variant="outline" 
                    size="sm"
                    onClick={() => scrollToSection('#contact')}
                    className="whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-information-line w-4 h-4 flex items-center justify-center"></i>
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="text-center bg-gradient-to-r from-red-900/20 to-yellow-900/20 backdrop-blur-sm rounded-3xl border border-red-500/20 p-12">
          <h3 className="text-3xl font-bold text-white mb-4">
            Siap Merasakan Pengalaman Kuliner Jepang?
          </h3>
          <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto">
            Jelajahi menu lengkap kami dan nikmati cita rasa autentik Jepang dengan teknologi pemesanan modern
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/customer">
              <Button variant="primary" size="lg" className="shadow-2xl shadow-red-500/50 whitespace-nowrap cursor-pointer">
                <i className="ri-smartphone-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                Pesan Online Sekarang
              </Button>
            </Link>
            <Button 
              variant="outline" 
              size="lg"
              onClick={() => scrollToSection('#reservation')}
              className="shadow-2xl shadow-yellow-500/50 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-line mr-2 w-5 h-5 flex items-center justify-center"></i>
              Reservasi Meja
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}